import axios, { AxiosResponse, AxiosInstance, AxiosError, InternalAxiosRequestConfig, AxiosHeaders } from 'axios';
import { PRE_SELECTED_CUSTOMER_ID_FOR_MENU } from 'appConstants';

const serviceUrl = process.env.GATEWAY_URL;

const $host = axios.create({
	baseURL: serviceUrl,
});
const $authHost = axios.create({
	baseURL: serviceUrl,
});
const $authHostDownloadBlob = axios.create({
	baseURL: serviceUrl,
	responseType: 'blob',
});

const authInterceptor = (config: InternalAxiosRequestConfig) => {
	const headers = AxiosHeaders.from(config.headers ?? {});
	headers.set('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
	config.headers = headers;
	return config;
};

$authHost.interceptors.request.use(authInterceptor);
$authHostDownloadBlob.interceptors.request.use(authInterceptor);

let refreshing_token: null | Promise<AxiosResponse<{ accessToken: Nullable<string>; refreshToken: Nullable<string> }>> =
	null;

const refresh_token = () => {
	const dataRefreshToken = {
		clientId: 'SecretClient',
		clientSecret: 'Secret',
		refreshToken: localStorage.getItem('refreshToken'),
	};
	return $host.post('/api/Auth/RefreshToken', dataRefreshToken);
};

const refreshTokenInterceptor = async (err: AxiosError, host: AxiosInstance) => {
	let isRetry = false;
	if (err.response && err.response.status === 401 && !isRetry) {
		isRetry = true;
		try {
			refreshing_token = refreshing_token ? refreshing_token : refresh_token();
			let responseRefresh = await refreshing_token;
			refreshing_token = null;
			if (responseRefresh.data.accessToken && responseRefresh.data.refreshToken) {
				localStorage.setItem('accessToken', responseRefresh.data.accessToken);
				localStorage.setItem('refreshToken', responseRefresh.data.refreshToken);
			}
			if (!err.config) {
				return Promise.reject(err);
			}
			return host.request(err.config);
		} catch (err) {
			console.error(err);
			localStorage.removeItem('accessToken');
			localStorage.removeItem('refreshToken');
			localStorage.removeItem(PRE_SELECTED_CUSTOMER_ID_FOR_MENU);
			window.location.href = '/';
			return Promise.reject(err);
		}
	}
	return Promise.reject(err);
};

$authHost.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => refreshTokenInterceptor(error, $authHost),
);

$authHostDownloadBlob.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => refreshTokenInterceptor(error, $authHostDownloadBlob),
);

export { $host, $authHost, $authHostDownloadBlob };
